<template>
  <div>
    <el-card>
      <div slot="header">新增快捷回复</div>
      <el-form :model="form" inline>
        <el-form-item label="标题"><el-input v-model="form.title" /></el-form-item>
        <el-form-item label="内容"><el-input v-model="form.content" style="width:260px;" /></el-form-item>
        <el-form-item><el-button type="primary" @click="submit">新增</el-button></el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top:16px;">
      <div slot="header">快捷回复列表</div>
      <el-table :data="list">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="title" label="标题" width="180" />
        <el-table-column prop="content" label="内容" />
        <el-table-column label="操作" width="180">
          <template slot-scope="{ row }">
            <el-button size="mini" @click="edit(row)">保存</el-button>
            <el-button size="mini" type="danger" @click="remove(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { quickReplies, createQuickReply, updateQuickReply, deleteQuickReply } from '../api/merchant';
export default {
  data() {
    return { list: [], form: { title: '', content: '' } };
  },
  methods: {
    async load() {
      const { data } = await quickReplies();
      this.list = data.data || [];
    },
    async submit() {
      await createQuickReply(this.form);
      this.form = { title: '', content: '' };
      await this.load();
    },
    async edit(row) {
      await updateQuickReply(row.id, { title: row.title, content: row.content, sort_order: row.sort_order || 0 });
      await this.load();
    },
    async remove(id) {
      await deleteQuickReply(id);
      await this.load();
    }
  },
  created() {
    this.load();
  }
};
</script>

